module.exports = __webpack_public_path__ + "img/logo.54d37ce2.png";